export enum administratorRole {
  Principal = 'Principal',
  'Vice Principal' = 'Vice Principal',
  'Executive Director' = ' Executive Director',
  'CAO (Chief Academic Officer)' = ' CAO (Chief Academic Officer)',
  'CBO (Chief Business Officer)' = 'CBO (Chief Business Officer)',
  'COO (Chief Operations Officer)' = ' COO (Chief Operations Officer)',
  Teacher = ' Teacher',
  Maintenance = 'Maintenance',
  'Cafeteria Staff' = 'Cafeteria Staff',
}

export const FILTER_OPTIONS = {
  All: 'all',
  Online: 'online',
  Offline: 'offline',
};

export const SIGNUP_TAB_TITLES = {
  TeachersOnly: 'Teachers Only',
  EduPlatform: 'EDU School Platform',
};

export const SCHOOL_FILTER_OPTIONS = {
  All: 'all',
  Subscription: 'subscription',
};
